export default function ({ intent, section, items }) {
    return {
        type: 'SET_ITEMS',
        intent, section, items
    }
}